'use strict';

import st from './scrollto';
import { TimelineLite } from 'gsap';

let self;
export default self = {
  hamburger : document.querySelector('#hamburger'),
  header: document.querySelector('header'),
  logo: document.querySelector('.site-logo'),
  mainNav: document.querySelectorAll('#main-navigation ul.menu > li'),
  utilNav: document.querySelectorAll('#utility-nav li'),
  body : document.querySelector('body'),
  btnBackToTop : document.getElementById('btn-back-to-top'),
  subMenu: document.querySelector('#main-navigation ul.submenu'),

  navOpenClass : 'nav-open',
  headerHeightCollapsed : 50,
  delta : 200,

  init : () => {

    self.hamburger.addEventListener('click', ()=>{
      if(!document.body.classList.contains('is-animating')){
        self.toggle();
      }
    });

    if ( document.body.classList.contains("home") ) {
      window.addEventListener('scroll', self.debounce(self.onScroll))
      self.onScroll()
    }

    if (self.btnBackToTop) self.btnBackToTop.addEventListener("click", () => st.animate(0, 1000))

    if (window.innerWidth <= 601){
      self.accordion();
    }

  },

  toggle : () => {

    if(!self.body.classList.contains('is-open')){
      if (window.innerWidth >= 601) {
        self.openNav();
      } else {
        self.openNavMobile();
      }
    } else {
      self.closeNav();
    }

  },

  openNav : () => {
    const tl = new TimelineLite();
    tl
    .set(self.body, {className: '+=is-animating'})
    .set(self.body, {className: '+=is-open'})
    .set('#main-navigation', {display: 'block'})
    .set([self.logo, self.mainNav, self.utilNav], {autoAlpha: 0})
    .to(self.header, 0.4, {yPercent: -100, ease: Power3.easeOut})
    .set(self.header, {autoAlpha: 0, yPercent: 0})
    .add('in')
    .to(self.header, 0.4 ,{autoAlpha: 1}, 'in')
    .set(document.documentElement, {className: '+=nav-open'}, 'in')
    .to(self.logo, 0.4, {autoAlpha: 1, clearProps: 'all'})
    .add('navIn', '-=0.2')
    .staggerFromTo(self.utilNav, 0.6, {y: -20}, {autoAlpha: 1, y: 0}, 0.1, 'navIn')
    .staggerFromTo(self.mainNav, 0.8, {x: -20}, {autoAlpha: 1, x: 0}, 0.2, 'navIn')
    .set(self.body, {className: '-=is-animating'});
  },

  openNavMobile : () => {
    const tlMobile = new TimelineLite();
    tlMobile
    .set(self.body, {className: '+=is-animating'})
    .set(self.body, {className: '+=is-open'})
    .set('#main-navigation', {display: 'block'})
    .set([self.logo, self.mainNav, self.utilNav], {autoAlpha: 0})
    .to(self.header, 0.6, {yPercent: -100, ease: Power3.easeOut})
    .set(self.header, {autoAlpha: 0, yPercent: 0})
    .add('in')
    .to(self.header, 0.5 ,{autoAlpha: 1}, 'in')
    .set(document.documentElement, {className: '+=nav-open'}, 'in')
    .to(self.logo, 0.6, {autoAlpha: 1, clearProps: 'all'})
    .staggerFromTo(self.mainNav, 0.6, {x: -20}, {autoAlpha: 1, x: 0}, 0.1, '-=0.1')
    .staggerFromTo(self.utilNav, 0.6, {x: -20}, {autoAlpha: 1, x: 0}, 0.1, '-=0.75')
    .set(self.body, {className: '-=is-animating'});
  },

  closeNav : () => {
    const tlBack = new TimelineLite();
    tlBack
    .set(self.body, {className: '+=is-animating'})
    .add('out')
    .to(self.header, 0.5, {autoAlpha: 0}, 'out')
    .set(document.documentElement, {className: '-=nav-open'})
    .set(self.header, {yPercent: -100, autoAlpha: 1})
    .to(self.header, 0.6, {yPercent: 0, ease: Power3.easeOut}, '+=0.2')
    .set(self.body, {className: '-=is-open'})
    .set(self.body, {className: '-=is-animating'});
  },

  accordion : () => {
    [...self.mainNav].forEach((element)=>{
      element.addEventListener('click', function(e) {
        if (element.lastElementChild.style.maxHeight){
          element.lastElementChild.style.maxHeight = null;
        } else {
          element.lastElementChild.style.maxHeight = element.lastElementChild.scrollHeight + "px";
        }
      });

    });
  },

  onScroll : e => {

    if (window.innerWidth >= 601) {
      // Remove expanded class once you scroll past the cover
      if (
        window.pageYOffset > (window.innerHeight / 2) -  self.headerHeightCollapsed
        && self.header.classList.contains("expanded")
      ) {
        self.header.classList.remove("expanded")
      }

      // Add the expanded class once you are back at the cover
      if (
        window.pageYOffset < (window.innerHeight / 2) -  self.headerHeightCollapsed
        && !self.header.classList.contains("expanded")
      ) {
        self.header.classList.add("expanded")
      }
    }
  },

  debounce : (func, wait = 10, immediate = true) => {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

}
